import { DocumentFormUploadFileMetaData } from '@Types/api/form';
import FolderConstantPath from '@Enum/FolderConstantPath.enum';

export const getDocumentFolder = (reqId: string | number): string => {
  const output = `${FolderConstantPath.DOCUMENT}/it-request/${reqId}`;
  return output;
};

export const getFormUploadFileMetaData = (
  reqFileId: string,
  fileName: string
): DocumentFormUploadFileMetaData => {
  const body = {
    path: getDocumentFolder(reqFileId),
    filename: fileName,
    name: fileName,
  };
  return body;
};
